/*
 * $Id:: index.js 2021/03/02 03:34 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React, { useEffect, useState } from 'react';

import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import AddIcon from '@material-ui/icons/Add';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { globals as globalsSlice } from '../../../../app/globalsSlice';
import { ReactComponent as LaunchIcon } from '../../../../assets/images/launch_24px.svg';
import Card from '../../../../components/Card';
import { t } from '../../../../providers';
import { getLocale } from '../../../../providers';
import { me as meSlice } from '../../../AuthenticatedPage/authenticationSlice';
import { SLICE_NAME } from '../../../AuthenticatedPage/constants';
import ChildAccountsTable from './ChildAccountsTable';
import FieldsMissingDialog from './FieldsMissingDialog';

const useStyles = makeStyles((theme) => ({
    headerSection: {
        paddingBottom: '15px',
        paddingTop: '15px',
    },
    cardTitle: {
        fontSize: '1rem',
        fontWeight: '400',
        color: '#4D4D4D',
        marginTop: '10px',
        letterSpacing: '0.15px',
        fontStyle: 'normal',
        lineHeight: '125%',
    },
    addButton: {
        color: theme.palette.text.mainBlue,
        borderColor: theme.palette.text.mainBlue,
        borderRadius: '3px',
        height: '32px',
    },
    content: {
        marginTop: '3rem',
        marginBottom: '3rem',
    },
    childAccountBtn: {
        height: '32px',
        minWidth: '10rem',
        borderRadius: '2px',
        marginLeft: '0',
        '&:focus-visible': {
            backgroundColor: 'rgba(209, 224, 194, 0.2)',
            outline: 'none',
            border: '2px dashed #4F7E1D',
            borderRadius: '3px',
        },
    },
}));

const ChildAccounts = () => {
    const classes = useStyles();
    const history = useHistory();
    const dispatch = useDispatch();
    const me = useSelector(meSlice);
    const { globals } = useSelector(globalsSlice) || {};
    const admin_roles = ['ROLE_ACCOUNT_ADMINISTRATOR', 'ROLE_CHILD_ACCOUNT_ADMIN'];


    const [dialogOpen, setDialogOpen] = useState(false);

    useEffect(() => {
        dispatch({ type: `${SLICE_NAME}/getUserinfo` });
    }, [dispatch]);

    const addAccount = (event) => {
        event.preventDefault();
        const lang = getLocale();
        window.open(`${globals.childAccountLinks['inpi.child.account.create.text']['link']}${lang}`, '_blank');
    };

    const editAccount = (event) => {
        event.preventDefault();
        const lang = getLocale();
        window.open(`${globals.accountLinks['inpi.account.text']['link']}${lang}`, '_blank');
    };

    const navigateToProfile = (event) => {
        event.preventDefault();
        setDialogOpen(false);
        history.push('/my-account/profile-details');
    };

    const cancelMessage = (event) => {
        event.preventDefault();
        setDialogOpen(false);
    };

    return (
        <div style={{ marginTop: '-48px' }}>
            <Card canEdit={false}>
                <Grid
                    justify={'space-between'}
                    alignItems={'center'}
                    container
                    className={classes.headerSection}
                    style={{ borderBottom: '1px solid #ccc' }}>
                    <Grid item>
                        <Typography className={classes.cardTitle}>{t('account.details')}</Typography>
                    </Grid>
                    <Grid item>
                        <Button
                            disableFocusRipple
                            aria-label={`${t('edit.my.account')}. ${t('open.new.tab')}`}
                            className={classes.childAccountBtn}
                            variant={'outlined'}
                            onClick={editAccount}>
                            {t('edit.my.account').toUpperCase()}
                            <LaunchIcon style={{ paddingLeft: '5px' }} aria-hidden="true" focusable="false" />
                        </Button>
                    </Grid>
                </Grid>
                
                <Grid justify={'space-between'} alignItems={'center'} container className={classes.headerSection}>
                    <Grid item>
                        <Typography className={classes.cardTitle}>{t('child.accounts')}</Typography>
                    </Grid>
                    <Grid item>
                        <Button
                            disableFocusRipple
                            aria-label={`${t('add.child.account')}. ${t('open.new.tab')}`}
                            className={classes.childAccountBtn}
                            variant={'outlined'}
                            onClick={addAccount}>
                            <AddIcon style={{ paddingRight: '5px' }} aria-hidden="true" focusable="false" />
                            {t('add.child.account').toUpperCase()}
                            <LaunchIcon style={{ paddingLeft: '5px' }} aria-hidden="true" focusable="false" />
                        </Button>
                    </Grid>
                </Grid>
                <ChildAccountsTable globals={globals} tableAriaLabel={t('details.about.profile.preferences')} />
            </Card>
            <FieldsMissingDialog open={dialogOpen} onAccept={navigateToProfile} onCancel={cancelMessage} />
        </div>
    );
};

export default ChildAccounts;
